import pdfMake from 'pdfmake/build/pdfmake';
import 'pdfmake/build/vfs_fonts';

import { clone } from '../../schedule';
import Swal from 'sweetalert2';
import { openPdfInNewTabOrAlert } from '../../pdfOpen';
import profilePlaceholder from './Portrait_Placeholder.png';
import { pdf_concatenate } from '../../candidates';
import { imageToBase64 } from 'Common.functions';
const bgGuide = require('./AVERY_5384.png');
let profilePlaceholderBase64 = null;

// 1 inch = 72 units.
// LETTER size is 612x792

const tableLayouts = {
  customTable: {
    hLineWidth: (i, node) => {
      return 0;
      // if (i === 0 || i === node.table.body.length) {
      //   return 0;
      // }
      // return i === node.table.headerRows ? 2 : 1;
    },
    vLineWidth: (i) => {
      return 0;
    },
    hLineColor: (i) => {
      return i === 1 ? 'black' : '#aaa';
    },
    paddingLeft: (i) => {
      return 0;
    },
    paddingRight: (i, node) => {
      return 0;
    },
    paddingTop: (i, node) => {
      return 0;
    },
    paddingBottom: (i, node) => {
      return 0;
    },
  },
};

const truncate = (wordToTruncate, limit = 0, forcedCut) => {
  if (wordToTruncate == null) {
    return '';
  }
  if (limit == 0 || wordToTruncate.length < limit + 1) {
    return wordToTruncate;
  } else if (forcedCut) {
    return `${wordToTruncate.slice(0, limit)}`;
  } else if (wordToTruncate.length > limit + 1) {
    return `${wordToTruncate.slice(0, limit - 5)}. . .`;
  }
};

const createPDFProper = async (data) => {
  return new Promise(async (resolve, reject) => {
    try {
      const { interviewDate, candidates, department, onProgress } = data;

      const rows = [];
      let counter = 0;
      const renderCard = (candidate, counter) => {
        const { userPhotoBase64, error } = candidate;
        const cardRows = [];
        const userDetailRows = [];
        console.log('error: ', error);

        console.log('userPhotoBase64: ', userPhotoBase64);
        console.log('profilePlaceholderBase64: ', profilePlaceholderBase64);

        const userPhoto =
          userPhotoBase64 && !error
            ? {
                width: 100,
                columns: [
                  {
                    image: userPhotoBase64 ? `data:image/png;base64,${userPhotoBase64}` : null,
                    width: 80,
                  },
                ],
                margin: [10, 0, 10, 0],
              }
            : {
                width: 100,
                columns: [
                  {
                    image: profilePlaceholderBase64 ? `data:image/png;base64,${profilePlaceholderBase64}` : null,
                    width: 80,
                  },
                ],
                margin: [10, 0, 10, 0],
              };

        userDetailRows.push([
          {
            style: { alignment: 'left', bold: true },
            text: `${candidate.LastName}, ${candidate.FirstName}`,
            // fontSize: 12,
            margin: [15, 0, 0, 0],
          },
        ]);

        userDetailRows.push([
          {
            style: { alignment: 'left' },
            text: `${candidate.CandidateSubHeading ? candidate.CandidateSubHeading : ' '}`,
            // fontSize: 12,
            margin: [15, 0, 0, 0],
          },
        ]);

        userDetailRows.push([
          {
            style: { alignment: 'left' },
            text: candidate.Email ? candidate.Email.match(/.{1,30}/g).join(' ') : ' ',
            // fontSize: 12,
            margin: [15, 0, 0, 0],
          },
        ]);

        if (candidate.CellPhone) {
          userDetailRows.push([
            {
              style: { alignment: 'left' },
              text: [
                { text: 'Cell Phone: ', bold: true },
                { text: `${candidate.CellPhone ? candidate.CellPhone : ' '}` },
              ],
              margin: [15, 0, 0, 0],
            },
          ]);
        }

        if (candidate.PhoneNumber) {
          userDetailRows.push([
            {
              style: { alignment: 'left' },
              text: [
                { text: 'Phone Number: ', bold: true },
                { text: `${candidate.PhoneNumber ? candidate.PhoneNumber : ' '}` },
              ],
              margin: [15, 0, 0, 0],
            },
          ]);
        }

        userDetailRows.push({
          width: 185,
          text: department.DepartmentName,
          //   fontSize: 12,
          style: { alignment: 'left' },
          margin: [15, 0, 0, 0],
        });

        cardRows.push({
          columns: [userDetailRows, userPhoto],
          margin: [0, 20, 0, 0],
        });

        if (candidate.HobbiesAndInterests) {
          cardRows.push({
            width: 185,
            text: {
              text: [
                { text: 'Hobbies: ', style: { bold: true }, margin: [0, 0, 10, 0] },
                {
                  text: pdf_concatenate({
                    string: `${candidate.HobbiesAndInterests ? candidate.HobbiesAndInterests : ''}`,
                    maxLimit: 350,
                  }),
                },
              ],
            },
            //   fontSize: 12,
            style: { alignment: 'left' },
            margin: [15, 10, 0, 0],
          });
        }

        // cardRows.push({ canvas: [{ type: 'line', x1: 20, y1: 0, x2: 260.2, y2: 0, lineWidth: 1 }] });

        return cardRows;
      };

      // Process candidates in chunks to keep UI responsive
      const CHUNK_SIZE = 50;
      const totalCandidates = candidates.length;

      while (counter < totalCandidates) {
        const chunkEnd = Math.min(counter + CHUNK_SIZE, totalCandidates);

        // Process one chunk
        for (let i = counter; i < chunkEnd; i++) {
          const columns = [];
          const tableRow = [];

          columns.push({ width: 3.95 * 72, columns: [renderCard(candidates[i], i)] });
          tableRow.push(renderCard(candidates[i], i));
          i++;
          if (i < totalCandidates) {
            columns.push({ width: 3.95 * 72, columns: [renderCard(candidates[i], i)] });
            tableRow.push(renderCard(candidates[i], i));
          } else {
            tableRow.push({ text: '' });
          }

          rows.push(tableRow);
        }

        counter = chunkEnd;

        // Report progress
        if (onProgress) {
          onProgress({ current: counter, total: totalCandidates });
        }

        // Yield to browser between chunks to keep UI responsive
        if (counter < totalCandidates) {
          await new Promise((resolve) => setTimeout(resolve, 0));
        }
      }

      if (rows.length <= 0) {
        Swal.fire('Error', 'There are no Candidates for this Interview Date. There is nothing to print!', 'error');
        reject(new Error('No candidates to print'));
        return;
      }

      let pdfObject = [
        {
          table: { heights: 212, widths: [3.95 * 72, 3.95 * 72], body: rows, dontBreakRows: true },
          layout: 'customTable',
        },
      ];

      const docDefinition = {
        info: { title: 'Candidate Fact Cards' },
        pageSize: 'LETTER',
        pageOrientation: 'portrait',
        content: pdfObject,
        defaultStyle: {
          fontSize: 11,
        },

        pageMargins: [0.25 * 72, 72, 0.25 * 72, 72],
      };

      const pdfDocGenerator = pdfMake.createPdf(docDefinition, tableLayouts);
      openPdfInNewTabOrAlert({
        pdfDocGenerator,
        downloadTitle: 'Candidate_Fact_Cards',
        previewCallback: data.previewCallback,
      });
      resolve();
      // const pdfDocGenerator = pdfMake.createPdf(docDefinition, tableLayouts);

      // pdfDocGenerator.getDataUrl((dataURL) => {
      //   console.log('dataURL: ', dataURL);

      //   const newWindow = window.open(dataURL ? dataURL : '', '_blank', 'noopener,noreferrer');
      //   console.log('newWindow: ', newWindow);

      //   if (newWindow) {
      //     // newWindow.location.href = dataURL;
      //     resolve(dataURL);
      //   } else {
      //     reject(new Error('Failed to open PDF window - popup blocked?'));
      //   }
      // });
    } catch (error) {
      console.log('pdfDocGenerator error: ', error);
      reject(error);
    }
  });
};

export const createPDFForCandidateFactCards = ({
  interviewDate,
  department,
  candidates = [],
  callback,
  onProgress,
  previewCallback,
}) => {
  const candidatesCopy = clone(
    candidates.sort((a, b) => {
      const textA = `${a.LastName}, ${a.FirstName}`.toUpperCase();
      const textB = `${b.LastName}, ${b.FirstName}`.toUpperCase();

      return textA < textB ? -1 : textA > textB ? 1 : 0;
    }),
  );
  if (department.DepartmentLogo) {
    Promise.all([
      ...candidatesCopy.map((c) => {
        return new Promise((resolve, reject) => {
          if (c.PhotoUrl) {
            imageToBase64({
              url: c.PhotoUrl,
              callback: (err, base64Img) => {
                if (err) {
                  resolve({ error: true, ...c });
                  return;
                }
                c.userPhotoBase64 = base64Img;
                resolve(c);
              },
            });
          } else {
            resolve(c);
          }
        });
      }),
      new Promise((resolve, reject) => {
        imageToBase64({
          url: profilePlaceholder,
          callback: (err, base64) => {
            console.log('err: ', err);
            console.log('base64: ', base64);

            if (err) {
              reject(err);
              return;
            }
            profilePlaceholderBase64 = base64;

            resolve(base64);
          },
        });
      }),
    ])
      .then((res) => {
        return createPDFProper({ candidates: candidatesCopy, department, onProgress, previewCallback });
      })
      .then(() => {
        if (!previewCallback && callback) {
          callback();
        }
      })
      .catch((err) => {
        console.error('createPDF err: ', err);
        if (previewCallback) {
          previewCallback(null, null, err);
        } else if (callback) {
          callback(err);
        }
      });
  } else {
    Promise.all([
      ...candidatesCopy.map((c) => {
        return new Promise((resolve, reject) => {
          if (c.PhotoUrl) {
            imageToBase64({
              url: c.PhotoUrl,
              callback: (err, base64Img) => {
                if (err) {
                  resolve({ error: true, ...c });
                  return;
                }
                c.userPhotoBase64 = base64Img;
                resolve(c);
              },
            });
          } else {
            resolve(c);
          }
        });
      }),
      new Promise((resolve, reject) => {
        imageToBase64({
          url: profilePlaceholder,
          callback: (err, base64) => {
            if (err) {
              reject(err);
              return;
            }
            profilePlaceholderBase64 = base64;
            resolve(base64);
          },
        });
      }),
    ])
      .then((res) => {
        return createPDFProper({ candidates: candidatesCopy, department, onProgress, previewCallback });
      })
      .then(() => {
        if (!previewCallback && callback) {
          callback();
        }
      })
      .catch((err) => {
        console.error('createPDF err: ', err);
        if (previewCallback) {
          previewCallback(null, null, err);
        } else if (callback) {
          callback(err);
        }
      });
  }
};
